export class ExtraSalesModal {
    #refs;
    constructor(element) {
        this.#refs = {
            el: element,
            select: element.querySelector('[data-select] select')
        }

        this.#init();
    }

    #watchDropdownChanges() {
        this.#refs.select.addEventListener('change', this.#toggleAddEarmoldButton.bind(this));
    }

    #toggleAddEarmoldButton() {
        const disabledButton = () => {
            addEarmoldButton.disabled = true;
            addEarmoldButton.setAttribute('disabled', '');
            addEarmoldButton.classList.add('is-disabled');
        }

        const enabledButton = () => {
            addEarmoldButton.disabled = false;
            addEarmoldButton.removeAttribute('disabled');
            addEarmoldButton.classList.remove('is-disabled');
        }

        const addEarmoldButton = this.#refs.el.querySelector('input[type="submit"][id*="AddEarmoldTextEditableButton"]');
        // Toggle button logic
        this.validateButton ? enabledButton() : disabledButton();
    }

    get validateButton() {
        const dropdownValue = this.#refs.select.value;
        return dropdownValue && dropdownValue.toLowerCase() !== 'none';
    }

    #init() {
        this.#watchDropdownChanges();
        this.#toggleAddEarmoldButton();
    }
}